import { RemoteLessonEmployeeRecipientDTO, SelectOptionType, UserId } from 'types';

export const parseRemoteLessonEmployeeRecipientDTOIntoSelectOptionType: (
    employeeUser: RemoteLessonEmployeeRecipientDTO,
) => SelectOptionType<UserId, string> = (employeeUser) => ({
    value: employeeUser.userId,
    label: employeeUser.name,
});
